var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// Multivariate Dependencies
import React from 'react';
// Utils
import ReactDOM from 'react-dom';
/**
 * @deprecated Do not use legacy components anymore.
 */
var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    function Portal(props) {
        var _this = _super.call(this, props) || this;
        _this.el = document.createElement('div');
        return _this;
    }
    Portal.prototype.componentDidMount = function () {
        document.body.append(this.el);
    };
    Portal.prototype.componentWillUnmount = function () {
        this.el.remove();
    };
    Portal.prototype.render = function () {
        var children = this.props.children;
        return ReactDOM.createPortal(children, this.el);
    };
    return Portal;
}(React.PureComponent));
export default Portal;
//# sourceMappingURL=Portal.js.map